<template>
  <hm-content title="查看预约列表">
    <div class="table-panel flex flex-between">
      <span class="activity-name">{{ activityListDetails.actName }}</span>
      <div class="flex flex-between">
        <el-select
          clearable
          v-model="actSite"
          placeholder="选择场地"
          @change="selectAddress"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.actSite"
            :value="v.actSite"
            v-for="(v, i) in siteList"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          :disabled="!actSite"
          clearable
          v-model="subRoundId"
          placeholder="选择场次"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.actRound"
            :value="v.id"
            v-for="(v, i) in roundList"
            :key="i"
          ></el-option>
        </el-select>
        <el-input
          class="mr10"
          size="small"
          v-model="keyword"
          placeholder="请输入用户名/电话"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="hm-radio-group">
        <el-radio-group v-model="timeStatus" size="small" @change="switchTab">
          <el-radio-button label="all"
            >全部({{ subscrobeActListCount.allNum }})</el-radio-button
          >
          <el-radio-button label="applied"
            >已报名({{ subscrobeActListCount.appliedNum }})</el-radio-button
          >
          <el-radio-button label="completed"
            >已完成({{ subscrobeActListCount.completedNum }})</el-radio-button
          >
          <el-radio-button label="canceled"
            >已取消({{ subscrobeActListCount.canceledNum }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-table
        stripe
        border
        :data="subscribeActList.records"
        style="width: 100%"
        id="table"
        ref="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="用户名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="用户卡号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="联系方式"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="收费模式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.actCostIntegral"
              >{{ scope.row.actCostIntegral }}积分</span
            >
            <span v-if="scope.row.actCostMoney"
              >{{ scope.row.actCostMoney }}元</span
            >
            <span
              v-if="!scope.row.actCostIntegral && !scope.row.actCostIntegral"
              >免费</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="authCode"
          label="核销码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actSite"
          label="活动地址"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actRound"
          label="活动场次"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderStatus"
          label="订单状态"
        >
          <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.orderStatus == 2"
              >已取消</span
            >
            <span class="status success" v-show="scope.row.orderStatus == 1"
              >已报名</span
            >
            <span class="status success" v-show="scope.row.orderStatus == 3"
              >已完成</span
            >
            <span
              class="status success"
              v-show="
                scope.row.orderStatus != 1 &&
                  scope.row.orderStatus != 2 &&
                  scope.row.orderStatus != 3
              "
              >未支付</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="chargeStatus"
          label="核销状态"
        >
          <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.chargeStatus == 1"
              >已核销</span
            >
            <span class="status success" v-show="scope.row.chargeStatus == 0"
              >未核销</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip
                class="item mr10"
                content="核销"
                placement="top"
                v-if="scope.row.chargeStatus == 0"
              >
                <div class="pointer" @click="openWriteOff(scope.row)">
                  <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip
                class="item mr10"
                content="不核销"
                placement="top"
                v-if="scope.row.chargeStatus == 1"
              >
                <div class="pointer" @click="remove(scope.row, '不核销', 0)">
                  <span class="hmicon icon-xingzhuanggaizhang blue"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="subscribeActList.total"
        @current-change="paging"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <!-- 预约活动核销选择门店弹框 -->
    <verify-shop-dialog
      ref="verifyShopDialogRef"
      :store-code="storeCode"
      @confirmed="onShopConfirmed"
      @fallback="onShopFallback"
    />
  </hm-content>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
import VerifyShopDialog from "@/components/VerifyShopDialog.vue";

export default {
  components: {
    VerifyShopDialog
  },
  data() {
    return {
      roundList: [],
      siteList: [],
      actSite: "",
      subRoundId: "",
      actName: "",
      dialogVisible: false,
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "all",
      pageSize: 10,
      date: [],
      keyword: "",
      authCode: "",
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      auditState: "",
      isOutputing: false,
      chargeStatus: "",
      // 核销选择门店相关
      storeCode: ""
    };
  },
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.actName = this.$route.query.actName;
    this.queryActivityDetails();
  },
  mounted() {
    this.queryList();
  },
  computed: mapGetters([
    "activityListDetails",
    "subscribeActList",
    "subscrobeActListCount",
    "allSubscribeActList"
  ]),
  watch: {
    activityListDetails(val) {
      this.siteList = val.roundBo;
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    queryActivityDetails() {
      this.$store.dispatch("queryActivityDetails", {
        id: this.$route.query.id
      });
    },
    selectAddress() {
      this.roundList = this.actSite
        ? this.siteList.find(p => p.actSite === this.actSite).subscribeRound
        : [];
      this.subRoundId = "";
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.subscribeActList.records;

            list.forEach(function(item) {
              if (!item.actCostIntegral && !item.actCostMoney) {
                item.charge = "免费";
              } else if (item.actCostIntegral) {
                item.charge = item.actCostIntegral + "积分";
              } else if (item.actCostMoney) {
                item.charge = item.actCostMoney + "元";
              }
              if (item.orderStatus == "2") {
                item.isorderStatus = "已取消";
              } else if (item.orderStatus == "1") {
                item.isorderStatus = "已报名";
              } else if (item.orderStatus == "3") {
                item.isorderStatus = "已完成";
              }
              if (item.chargeStatus == "1") {
                item.ischargeStatus = "已核销";
              } else if (item.chargeStatus == "0") {
                item.ischargeStatus = "未核销";
              }
            });

            const tHeader = [
              "订单号",
              "用户名",
              "用户卡号",
              "联系方式",
              "收费模式",
              "核销码",
              "活动地址",
              "活动场次",
              "订单状态",
              "核销状态",
              "操作"
            ];
            const filterVal = [
              "orderSn",
              "realName",
              "userName",
              "memberMobile",
              "charge",
              "authCode",
              "actSite",
              "actRound",
              "isorderStatus",
              "ischargeStatus",
              "operation"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "预约列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 打开核销门店选择弹框
    openWriteOff(row) {
      this.$refs.verifyShopDialogRef.openShop(row);
    },
    // 核销成功后刷新列表
    onShopConfirmed() {
      this.queryList();
    },
    // 未配置门店信息，走原核销流程
    onShopFallback(row) {
      this.remove(row, "要核销", 1);
    },
    remove(row, txt, status) {
      this.$confirm(
        "确定" + txt + "此预约信息？注：请仔细确认会员信息",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$store
            .dispatch("chargeOffFromId", {
              id: row.id,
              chargeStatus: status,
              userId: getLoginUser().userId,
              name: getLoginUser().name
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        actSite: this.actSite,
        subRoundId: this.subRoundId,
        timeStatus: this.timeStatus,
        subActId: this.$route.query.id,
        keyword: this.keyword
      };
      return this.$store.dispatch("querySubscribeActList", params);
    },
    queryAllList() {
      return this.$store.dispatch("querySubscribeActList", {
        pageSize: 999999,
        pageNo: this.currentPage,
        actSite: this.actSite,
        subRoundId: this.subRoundId,
        timeStatus: this.timeStatus,
        subActId: this.$route.query.id,
        keyword: this.keyword
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}
.activity-name {
  font-size: 14px;
  color: #e50065;
}
</style>
